import DossierPositionRepositoryInterface, { AgentPositionInterface } from '@/services/Dossier/position/interfaces';
import { AxiosInstance } from 'axios';

export default class DossierPositionRepository implements DossierPositionRepositoryInterface {
  constructor(
    private readonly axios: AxiosInstance,
  ) {
  }

  public async getAllPositions(): Promise<AgentPositionInterface[]> {
    const response = await this.axios.get('/dossier-controller/positions');

    return response.data;
  }
}
